import ReactDOM from "react-dom/client";
import "./styles.css";
import "./styles/muiStyles";
import reportWebVitals from "./reportWebVitals.ts";
import { App } from "./App.tsx";
import { router } from "./lib/router";
import { initSentry } from "./lib/sentry/sentry-init.ts";

initSentry(router);

// Expose a client-side navigate helper for E2E tests. Full-page navigations
// (page.goto) reload the JS bundle and wipe module-level state (e.g. the
// damage-3d mock store), so tests that need to navigate between pages within
// a single session must use this instead.
if (import.meta.env.MODE !== "production") {
	(window as unknown as Record<string, unknown>)["__navigate__"] = (
		url: string
	) => router.history.push(url);
}

// Initialize app with optional MSW mocking in development
async function initialize() {
	// Conditionally load and initialize MSW in development
	if (import.meta.env.MODE !== "production") {
		const { enableMocking } = await import("./mocks/setup");
		await enableMocking();
	}
}

// Initialize then render the app
void initialize().then(() => {
	const rootElement = document.getElementById("app");
	if (rootElement && !rootElement.innerHTML) {
		const root = ReactDOM.createRoot(rootElement);
		root.render(<App />);
	}
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
